import { Injectable } from '@angular/core';

@Injectable()
export class MetricService {
  private SPEED_DROPDOWN_CONFIG_METRIC_DICTIONARY: any = {
    recovery_index: {
      rowNumber: 0,
      optionList: [],
    },
    accumulation_index: {
      rowNumber: 0,
      optionList: [],
    },
    w_prime: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [kJ]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [kJ/kg]',
          id: 'data_point-2',
        },
      ],
    },
    max_lactate: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Max Lactate [mmol/l]',
          id: 'data_point-1',
        }
      ],
    },
    max_hr: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Maximum [bpm]',
          id: 'data_point-1',
        },
        {
          name: 'PWC150 [{0}]',
          id: 'data_point-2',
        },
      ],
    },
    economy: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Economy [ml/min/kg]',
          id: 'data_point-1',
        },
      ],
    },
    lt1: {
      rowNumber: 2,
      optionList: [
        {
          name: 'LT1 [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'LT1 [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    lt_1: {
      rowNumber: 2,
      optionList: [
        {
          name: 'LT1 [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'LT1 [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    vo2max: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [ml/min]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [ml/min/kg]',
          id: 'data_point-2',
        },
      ],
    },
    vlamax: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Vlamax [mmol/l/s]',
          id: 'data_point-1',
        }
      ],
    },
    anaerobic_threshold: {
      rowNumber: 2,
      optionList: [
        {
          name: 'MLSS [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'MLSS [{1}]',
          id: 'data_point-2',
        },
        {
          name: '% VO2max [%]',
          id: 'data_point-3',
        },
      ],
    },
    fat_max: {
      rowNumber: 3,
      optionList: [
        {
          name: 'MFO absolute [kcal/h]',
          id: 'data_point-1',
        },
        {
          name: 'MFO relative [kcal/h/kg]',
          id: 'data_point-2',
        },
        {
          name: 'FatMax [{0}]',
          id: 'data_point-3',
        }
      ],
    },
    carb_max: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Carbmax [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'Carbmax [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    available_glycogen: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [g]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [g/kg]',
          id: 'data_point-2',
        },
      ],
    },
    vo2_tau: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Tau [s]',
          id: 'data_point-1',
        },
      ],
    },
    avg_power: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Average Power [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'Average Power [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    max_power: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Maximum Speed [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'Maximum Speed [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    MLSS: {
      rowNumber: 2,
      optionList: [
        {
          name: 'MLSS [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'MLSS [{1}]',
          id: 'data_point-2',
        },
        {
          name: '% VO2max [%]',
          id: 'data_point-3',
        },
      ],
    },
    body_fat: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Body Fat [%]',
          id: 'data_point-1',
        },
      ],
    },
    MMSS: {
      rowNumber: 2,
      optionList: [
        {
          name: 'MMSS [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'MMSS [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    mmss: {
      rowNumber: 2,
      optionList: [
        {
          name: 'MMSS [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'MMSS [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    max_aerobic: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Maximum Aerobic Speed [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'Maximum Aerobic Speed [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    anaerobic_reserve: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Anaerobic Speed Reserve [{0}]',
          id: 'data_point-1',
        },
        {
          name: 'Anaerobic Speed Reserve [{1}]',
          id: 'data_point-2',
        },
      ],
    },
    min_lactate_eq: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Min Lactate Equivalent [mmol/l/s]',
          id: 'data_point-1',
        },
      ],
    },
  };

  private POWER_DROPDOWN_CONFIG_METRIC_DICTIONARY: any = {
    recovery_index: {
      rowNumber: 0,
      optionList: [],
    },
    accumulation_index: {
      rowNumber: 0,
      optionList: [],
    },
    w_prime: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [kJ]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [kJ/kg]',
          id: 'data_point-2',
        },
      ],
    },
    max_lactate: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Max Lactate [mmol/l]',
          id: 'data_point-1',
        },
      ],
    },
    max_hr: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Maximum [bpm]',
          id: 'data_point-1',
        },
        {
          name: 'PWC150 [Watt]',
          id: 'data_point-2',
        },
      ],
    },
    economy: {
      rowNumber: 0,
      optionList: [],
    },
    lt1: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    lt_1: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    vo2max: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [ml/min]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [ml/min/kg]',
          id: 'data_point-2',
        },
      ],
    },
    vlamax: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Vlamax [mmol/l/s]',
          id: 'data_point-1',
        },
      ],
    },
    anaerobic_threshold: {
      rowNumber: 3,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
        {
          name: '% VO2max [%]',
          id: 'data_point-3',
        },
      ],
    },
    fat_max: {
      rowNumber: 3,
      optionList: [
        {
          name: 'MFO absolute [kcal/h]',
          id: 'data_point-1',
        },
        {
          name: 'MFO relative [kcal/h/kg]',
          id: 'data_point-2',
        },
        {
          name: 'FatMax [Watt]',
          id: 'data_point-3',
        },
      ],
    },
    carb_max: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    available_glycogen: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [g]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [g/kg]',
          id: 'data_point-2',
        },
      ],
    },
    vo2_tau: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Tau [s]',
          id: 'data_point-1',
        },
      ],
    },
    avg_power: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    max_power: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    MLSS: {
      rowNumber: 3,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
        {
          name: '% VO2max [%]',
          id: 'data_point-3',
        },
      ],
    },
    body_fat: {
      rowNumber: 1,
      optionList: [
        {
          name: 'Body Fat [%]',
          id: 'data_point-1',
        },
      ],
    },
    MMSS: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    mmss: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    max_aerobic: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    anaerobic_reserve: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Absolute [Watt]',
          id: 'data_point-1',
        },
        {
          name: 'Relative [Watt/kg]',
          id: 'data_point-2',
        },
      ],
    },
    min_lactate_eq: {
      rowNumber: 2,
      optionList: [
        {
          name: 'Min Lactate Equivalent [mmol/l/s]',
          id: 'data_point-1',
        },
      ],
    },
  };

  public getSpeedDropdownConfigByMetric(metric: any): any {
    return this.SPEED_DROPDOWN_CONFIG_METRIC_DICTIONARY[metric.slug];
  }

  public getPowerDropdownConfigByMetric(metric: any): any {
    return this.POWER_DROPDOWN_CONFIG_METRIC_DICTIONARY[metric.slug];
  }
}
